import React from "react";

import ReactDOM from "react-dom";
import { useFormik } from "formik";
import * as yup from "yup";
import {
    Button,
    FormControl,
    FormControlLabel,
    FormLabel,
    InputAdornment,
    Radio,
    RadioGroup,
    TextField,
} from "@mui/material";
import {
    ArrowLeftCircle,
    CreditCard,
    Dialpad,
    Gift,
    Mail,
    SmartphoneDevice,
    User,
} from "iconoir-react";
import { useNavigate } from "react-router-dom";
import { inject, observer } from "mobx-react";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

const validationSchema = yup.object({
    email: yup
        .string("Nhập email của bạn")
        .email("Email không đúng")
        .required("Bắt buộc"),
});

const UpdateProfile = ({ authenticationStore, userStore }) => {
    const { currentUser, currentUserAvatar } = authenticationStore;
    const formik = useFormik({
        initialValues: {
            email: currentUser?.email,
            // ma_nv: currentUser?.ma_nv,
            home_phone: currentUser?.home_phone,
            phone: currentUser?.phone,
            // birthDate: currentUser?.birthDate,
            gender: currentUser?.gender,
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            // const birthDate = new Date(values.birthDate);
            // values = { ...values, birthDate: birthDate.toISOString() };
            try {
                await userStore.updateCurrentUser(values);
                authenticationStore.checkCurrentUser();
                navigate("/my-profile");
            } catch (err) {
                console.log(err);
            } finally {
            }
        },
    });

    const navigate = useNavigate();
    return (
        <div className="px-5 pt-6 pb-14">
            <div className="flex items-center">
                <ArrowLeftCircle
                    onClick={() => {
                        navigate(-1);
                    }}
                />
                <div className="ml-[22px] text-[#28353B] font-bold text-[28px] leading-[29px]">
                    Cập nhật thông tin
                </div>
            </div>

            <form onSubmit={formik.handleSubmit} className="mt-9">
                <TextField
                    fullWidth
                    id="email"
                    name="email"
                    label="Email"
                    value={formik.values.email}
                    onChange={formik.handleChange}
                    error={formik.touched.email && Boolean(formik.errors.email)}
                    helperText={formik.touched.email && formik.errors.email}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <Mail color="#23374D" />
                            </InputAdornment>
                        ),
                    }}
                    sx={{ mb: "20px" }}
                />
                {/* <TextField
                    fullWidth
                    id="ma_nv"
                    name="ma_nv"
                    label="Mã nhân viên"
                    value={formik.values.ma_nv}
                    onChange={formik.handleChange}
                    error={formik.touched.ma_nv && Boolean(formik.errors.ma_nv)}
                    helperText={formik.touched.ma_nv && formik.errors.ma_nv}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <CreditCard color="#23374D" />
                            </InputAdornment>
                        ),
                    }}
                    sx={{ mb: "20px" }}
                /> */}
                <TextField
                    fullWidth
                    id="home_phone"
                    name="home_phone"
                    label="Số máy nội bộ"
                    value={formik.values.home_phone}
                    onChange={formik.handleChange}
                    error={
                        formik.touched.home_phone &&
                        Boolean(formik.errors.home_phone)
                    }
                    helperText={
                        formik.touched.home_phone && formik.errors.home_phone
                    }
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <Dialpad color="#23374D" />
                            </InputAdornment>
                        ),
                    }}
                    sx={{ mb: "20px" }}
                />

                <TextField
                    fullWidth
                    id="phone"
                    name="phone"
                    label="Di động"
                    value={formik.values.phone}
                    onChange={formik.handleChange}
                    error={formik.touched.phone && Boolean(formik.errors.phone)}
                    helperText={formik.touched.phone && formik.errors.phone}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <SmartphoneDevice color="#23374D" />
                            </InputAdornment>
                        ),
                    }}
                    sx={{ mb: "20px" }}
                />
                {/* <LocalizationProvider
                    dateAdapter={AdapterDayjs}
                    sx={{ mb: "20px" }}
                >
                    <MobileDatePicker
                        id="birthDate"
                        label="Ngày sinh"
                        inputFormat="DD/MM/YYYY"
                        value={formik.values.birthDate}
                        onChange={(value) => {
                            formik.setFieldValue(
                                "birthDate",
                                Date.parse(value)
                            );
                        }}
                        renderInput={(params) => <TextField {...params} />}
                        error={
                            formik.touched.birthDate &&
                            Boolean(formik.errors.birthDate)
                        }
                        helperText={
                            formik.touched.birthDate && formik.errors.birthDate
                        }
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <Gift color="#23374D" />
                                </InputAdornment>
                            ),
                        }}
                    />
                </LocalizationProvider> */}
                <FormControl>
                    <FormLabel
                        id="demo-row-radio-buttons-group-label"
                        sx={{ color: "#16192C", fontWeight: 600, fontSize: 14 }}
                    >
                        Giới tính
                    </FormLabel>
                    <RadioGroup
                        row
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="row-radio-buttons-group"
                        id="gender"
                        value={formik.values.gender}
                        onChange={(value) => {
                            formik.setFieldValue("gender", value.target.value);
                        }}
                        sx={{ mb: "20px" }}
                    >
                        <FormControlLabel
                            value={1}
                            control={<Radio />}
                            label="Nam"
                        />
                        <FormControlLabel
                            value={0}
                            control={<Radio />}
                            label="Nữ"
                        />
                    </RadioGroup>
                </FormControl>
                <button
                    type="submit"
                    className="text-center text-white rounded bg-primary py-[9px] fixed bottom-[32px] left-[20px] right-[20px]"
                >
                    <div className="font-semibold text-[14px] leading-[22px]">
                        Cập nhật
                    </div>
                </button>
            </form>
        </div>
    );
};

export default inject(
    "authenticationStore",
    "userStore"
)(observer(UpdateProfile));
